<template>
	<div>
		<div class="breadcrumb-box">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<li class="breadcrumb-item back"><a href="javascript:void(0)" @click="goBack()">Back</a></li>
					<li class="breadcrumb-item"><a href="javascript:void(0)" @click="$router.go(-1)">Truck List</a></li>
					<li class="breadcrumb-item active" aria-current="page">Create Truck</li>
				</ol>
			</nav>
		</div>
		<div class="form-box mt-5">
			<div class="d-flex justify-content-between align-items-center">
				<h2 class="form-box__title">Data Truck</h2>
				<span class="form-box__info">{{ currentPage }} dari 2 halaman</span>
			</div>
			<div class="mt-3">
				<div v-if="currentPage === 1">
					<CreateTruckPage1
						:form="form"
						:region="region"
						:ekspedisiOptions="ekspedisiOptions"
						:truck="truck"
						@nextPage="nextPage"
					/>
				</div>
				<div v-if="currentPage === 2">
					<CreateTruckPage2
						:form="form"
						:yearOptions="yearOptions"
						@prevPage="prevPage"
						@submitForm="submitForm"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
// import Multiselect from "vue-multiselect";
import CreateTruckPage1 from './children/CreateTruckPage1.vue';
import CreateTruckPage2 from './children/CreateTruckPage2.vue';

export default {
	metaInfo: {
		title: "Create Truck",
	},
	data() {
		let startDate = moment().startOf("month").format("YYYY-MM-DD");
		let currentDate = moment().format("YYYY-MM-DD");
		let yearOptions = this.generateYearOptions(1990, 2023);

		return {
			currentPage: 1, // Initialize with page 1
			region : [],
			truck : [],
			ekspedisiOptions: [],
			filter: {
				start: startDate,
				end: currentDate,
				truck: null,
				region: null,
				plant: null,
			},
			form: {
				region: '',
				ekspedisi: '',
				nopol: '',
				odol: 'Y',
				kategori_truck: '',
				kapasitas_packing: '',
				kapasitas_buildup: '',
				tahun_produksi: '',
				gps: 'Y',
				asuransi: 'Y',
				type_truck: '',
				tanggal_mulai_efektif: currentDate,
				tanggal_akhir_efektif: currentDate,
				truck_bantuan: 0
			},
			yearOptions: yearOptions
		};
	},
	components: {
		// Multiselect,
		CreateTruckPage1,
		CreateTruckPage2
	},
	mounted () {
        this.region = this.$store.getters.getRegion;
	},
	created() {
		// Fetch data from the API
		axios
			.get("/api/master/ekspedisi")
			.then((response) => {
				if (response.data && response.data.data) {
					// Map the API data to match the format expected by vue-multiselect
					this.ekspedisiOptions = response.data.data.map((form) => ({
						id: form.id,
						name: form.name,
					}));
				}
			})
			.catch((error) => {
				console.error("Error fetching ekspedisi data:", error);
			});

		this.$http.get('/api/master/region')
		.then((resp) => {
			this.region = resp.data.data
		})
		.catch((err) => {
			console.log(err)
		})

		this.$http.get('/api/master/truck')
		.then((resp) => {
			this.truck = resp.data.data
		})
		.catch((err) => {
			console.log(err)
		})
	},
	watch: {
		"form.name"() {
			this.form.name = this.form.name.toUpperCase();
		},
	},
	methods: {
		nextPage() {
			this.currentPage = 2;
		},
		prevPage() {
			this.currentPage = 1;
		},
		goBack() {
			if (this.currentPage > 1) {
				this.currentPage = 1;
			} else {
				this.$router.go(-1);
			}
		},
		generateYearOptions(start, end) {
			const years = [];
			for (let year = start; year <= end; year++) {
				years.push({ value: year, text: year.toString() });
			}
			return years;
		},
		submitForm() {
			this.$swal
				.fire({
					title: "Are you sure?",
					text: "You are about to make a new data",
					icon: "warning",
					showCancelButton: true,
					confirmButtonColor: "#3085D6",
					cancelButtonColor: "#D33",
					confirmButtonText: "Simpan",
				})
				.then((result) => {
					if (result.value) {
						// Only send the 'id' of the selected ekspedisi
						const requestData = {
							...this.form,
							ekspedisi: this.form.ekspedisi
								? this.form.ekspedisi.id
								: null,
						};

						this.$http
							.post("/api/truck/save", requestData)
							.then((resp) => {
								this.$swal.fire({
									title: "Success!",
									icon: "success",
									type: "success",
									text: "Tambah truck berhasil disimpan",
								});
								this.$router.go(-1); // Go back to the previous route
							})
							.catch((error) => {
								console.error(
									"%cerror DashboardUserUM.vue line:78 ",
									"color: red; display: block; width: 100%;",
									err
								);
								this.$swal.fire({
									title: "Error!",
									icon: "error",
									type: "error",
									text: error.response.data.message,
								});
							});
					}
				});
		},
	},
};
</script>

<style scoped>
.innerBox {
	background-color: white;
	border-radius: 8px;
	box-shadow: 0px 3px 10px #0000000f;
	padding: 20px;
	padding-left: 40px;
}

.chart {
	background-color: white;
	border-radius: 8px;
	box-shadow: 0px 3px 10px #0000000f;
	padding: 20px;
	align-items: center;
}

.elegant--sub-title {
	font-size: 18px;
	font-weight: 500;
	color: #4d4d4d;
}

/* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

.stats--icon {
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
}

.table td,
.table th {
	text-align: center;
}

.news-image-1 img {
	max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
	text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
	text-align: left; /* To position the news-content on the bottom right */
}

.search-container {
	display: flex;
	align-items: center;
}

.dropdown-container {
	flex: 1;
	margin-right: 10px;
}

.searchbar-container {
	flex: 2;
}

.dropdown {
	width: 100%;
}

.searchbar {
	width: 50%;
	padding: 5px;
}
</style>
